import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { SelectItem } from 'primeng/api';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';

export interface ResourceListFilterValuesType {
  template?: number | null;
  roles?: Array<number> | null;
  locations?: Array<number> | null;
  languages?: Array<number> | null;
  start?: string | null;
  end?: string | null;
  name?: string | null;
}

@Component({
  selector: 'app-resources-filters',
  templateUrl: './resources-filters.component.html',
  styleUrls: ['./resources-filters.component.scss']
})
export class ResourcesFiltersComponent implements OnInit, OnChanges {

  @Input() options: { [key: string]: Array<SelectItem> };
  @Output() filterSet = new EventEmitter<ResourceListFilterValuesType>();

  loading = true;
  form: UntypedFormGroup = this.fb.group({
    template: new UntypedFormControl(null),
    start: new UntypedFormControl(null),
    end: new UntypedFormControl(null),
    roles: new UntypedFormControl(null),
    locations: new UntypedFormControl(null),
    languages: new UntypedFormControl(null),
    name: new UntypedFormControl(null),
  });
  minDate = new Date();

  optionsTemplates: Array<SelectItem> = [];
  optionsRoles: Array<SelectItem> = [];
  optionsLocations: Array<SelectItem> = [];
  optionsLanguages: Array<SelectItem> = [];

  constructor(
    private fb: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.options) {
      this.optionsTemplates = this.options.templates;
      this.optionsRoles = this.options.roles;
      this.optionsLocations = this.options.locations;
      this.optionsLanguages = this.options.languages;
      this.initForm();
    }
  }

  public onResetForm(): void {
    this.initForm();
  }

  public onSubmit(): void {
    if (this.form.valid) {
      this.filterSet.emit(this.getFilterValues());
    } else {
      FormHelper.markFormAsDirty(this.form);
    }
  }

  private initForm(): void {
    this.loading = false;
    this.form.patchValue({
      template: null,
      start: null,
      end: null,
      roles: null,
      locations: null,
      languages: null,
      name: null,
    });
  }

  private getFilterValues(): ResourceListFilterValuesType {
    return {
      template: this.form.get('template').value?.id || null,
      roles: this.form.get('roles').value?.map((entry: any) => {
        return entry.id;
      }) || null,
      locations: this.form.get('locations').value?.map((entry: any) => {
        return entry.id;
      }) || null,
      languages: this.form.get('languages').value?.map((entry: any) => {
        return entry.id;
      }) || null,
      start: (this.form.get('start').value) ? moment(this.form.get('start').value).format('YYYY-MM-DD') : null,
      end: (this.form.get('end').value) ? moment(this.form.get('end').value).format('YYYY-MM-DD') : null,
      name: this.form.get('name').value || null,
  };
  }

}
